import api from "../../../api/axios";

/** COMPANY-WORKSPACE-F2 — transport for merged F1 company presentation endpoints. */

function presentationsRoot(companyId) {
  return `/companies/${companyId}/presentations`;
}

function presentationPath(companyId, presentationId) {
  return `${presentationsRoot(companyId)}/${presentationId}`;
}

export function unwrapPresentationList(data) {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.results)) return data.results;
  return [];
}

export function listCompanyPresentations(companyId, params = {}, { signal } = {}) {
  return api
    .get(`${presentationsRoot(companyId)}/`, { params, signal })
    .then((res) => res.data);
}

export function createCompanyPresentation(companyId, body) {
  return api
    .post(`${presentationsRoot(companyId)}/`, body)
    .then((res) => res.data);
}

export function fetchCompanyPresentation(companyId, presentationId, { signal } = {}) {
  return api
    .get(`${presentationPath(companyId, presentationId)}/`, { signal })
    .then((res) => res.data);
}

export function updateCompanyPresentation(companyId, presentationId, body) {
  return api
    .patch(`${presentationPath(companyId, presentationId)}/`, body)
    .then((res) => res.data);
}

/** Revoke returns HTTP 204 with empty body. */
export function revokeCompanyPresentation(companyId, presentationId, body) {
  return api.post(`${presentationPath(companyId, presentationId)}/revoke/`, body);
}

export function reactivateCompanyPresentation(companyId, presentationId, body) {
  return api
    .post(`${presentationPath(companyId, presentationId)}/reactivate/`, body)
    .then((res) => res.data);
}

export function rotateCompanyPresentation(companyId, presentationId, body) {
  return api
    .post(`${presentationPath(companyId, presentationId)}/rotate/`, body)
    .then((res) => res.data);
}

export function handoverCompanyPresentation(companyId, presentationId, body) {
  return api
    .post(`${presentationPath(companyId, presentationId)}/handover/`, body)
    .then((res) => res.data);
}

export function maintainCompanyPresentationContact(companyId, presentationId, body) {
  return api
    .post(`${presentationPath(companyId, presentationId)}/contact/`, body)
    .then((res) => res.data);
}

export function fetchCompanyPresentationAnalytics(
  companyId,
  presentationId,
  { signal } = {},
) {
  return api
    .get(`${presentationPath(companyId, presentationId)}/analytics/`, { signal })
    .then((res) => res.data);
}

export function fetchCompanyPresentationAudit(
  companyId,
  presentationId,
  { signal } = {},
) {
  return api
    .get(`${presentationPath(companyId, presentationId)}/audit/`, { signal })
    .then((res) => res.data);
}

export const CORPORATE_PRESENTATION_MUTATION_FIELDS = [
  "property_id",
  "actor_membership_generation",
  "expected_revision",
  "responsible_user_id",
  "client_id",
  "internal_label",
  "price_mode",
  "custom_price",
  "custom_currency",
  "location_precision",
  "presentation_note",
  "include_video",
  "contact_phone",
  "contact_email",
  "include_contact_avatar",
  "confirm_company_fallback",
  "fallback_contact_name",
  "fallback_contact_phone",
  "fallback_contact_email",
  "use_fallback_contact",
  "expires_at",
  "media",
];
